/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import {
  Modal, Icon, List, Popup, Input
} from 'semantic-ui-react';
import { Scrollbars } from 'react-custom-scrollbars-2';
//import api from '../../api';
import closeBtn from '../../images/common/close-btn.svg';
import Loader from '../Loader/Loader';

class PrecisionLevelModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenMPL: props.isOpenMPL,
      precisionConfig: props.precisionConfig,
      defaultConfig: props.defaultConfig,
      isPopupLoading: props.isPopupLoading,
      //isShowCustomPrecisionLevelAllowed: props.isShowCustomPrecisionLevelAllowed,
      is_minimum_unique_rate_error: false,
      is_minimum_extracted_identifier_error: false,
      errorCode: null,
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.handleMURChange = this.handleMURChange.bind(this);
    this.handleMEIChange = this.handleMEIChange.bind(this);
    this.handleResetConfig = this.handleResetConfig.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps) {
    const {
      isOpenMPL, precisionConfig, defaultConfig, isPopupLoading
    } = this.props;

    if (prevProps.isOpenMPL !== isOpenMPL) {
      this.setState({
        isOpenMPL,
        precisionConfig,
        defaultConfig,
        is_minimum_unique_rate_error: false,
        is_minimum_extracted_identifier_error: false,
      });
    }

    if (prevProps.isPopupLoading !== isPopupLoading) {
      this.setState({
        isPopupLoading,
      });
    }
  }

  handleResetConfig() {
    const { defaultConfig } = this.state;
    this.setState({
      precisionConfig: defaultConfig,
      is_minimum_unique_rate_error: false,
      is_minimum_extracted_identifier_error: false,
    });
  }

  handleMURChange(e) {
    const { precisionConfig } = this.state;
    if (parseInt(e.target.value, 10) > 100 || parseInt(e.target.value, 10) < 0) {
      return false;
    }
    this.setState({
      precisionConfig: {
        ...precisionConfig,
        value_2: parseInt(e.target.value, 10),
      },
      is_minimum_unique_rate_error: false,
    });
  }

  handleMEIChange(e) {
    const { precisionConfig } = this.state;
    if (parseInt(e.target.value, 10) > 99999999 || parseInt(e.target.value, 10) < 0) {
      return false;
    }
    this.setState({
      precisionConfig: {
        ...precisionConfig,
        value_1: parseInt(e.target.value, 10),
      },
      is_minimum_extracted_identifier_error: false,
    });
  }

  onSubmit() {
    const { precisionConfig } = this.state;
    if (!this.validateFields()) {
      return null;
    }
    this.props.onSubmit(precisionConfig);
  }

  validateFields() {
    const { precisionConfig } = this.state;
    const validation = {
      is_minimum_unique_rate_error: true,
      is_minimum_extracted_identifier_error: true,
    };

    if (!precisionConfig.value_1) {
      this.setState({
        is_minimum_extracted_identifier_error: true,
      });
      validation.is_minimum_extracted_identifier_error = false;
      return;
    }
    validation.is_minimum_extracted_identifier_error = true;

    if (!precisionConfig.value_2) {
      this.setState({
        is_minimum_unique_rate_error: true,
      });
      validation.is_minimum_unique_rate_error = false;
      return;
    }
    validation.is_minimum_unique_rate_error = true;

    return (
      validation.is_minimum_extracted_identifier_error
      && validation.is_minimum_unique_rate_error
    );
  }

  closeModal(e) {
    if (e.target.classList[0] === 'save') {
      return;
    }
    this.props.closeModal();
  }

  render() {
    const {
      isPopupLoading,
      errorCode,
      isOpenMPL,
      precisionConfig,
      is_minimum_unique_rate_error,
      is_minimum_extracted_identifier_error,
      //isShowCustomPrecisionLevelAllowed,
    } = this.state;
    const { translate } = this.props;

    const getModalContent = () => {
      if (isPopupLoading) {
        return (
          <div className="modal_popup_wrap move_file_wrap">
            <div className="modal_popup_box move_file_box">
              <div className="modal_popup move_file">
                <div style={{ verticalAlign: 'middle', textAlign: 'center', marginTop: '20%' }}>
                  <Loader />
                </div>
              </div>
            </div>
          </div>
        );
      }

      return (
        <div className="modal_popup_wrap custom_precision_wrap">
          <div className="modal_popup_box custom_precision_box">
            <div className="modal_popup custom_precision">
              <h2 className="title">
                <span>
                  {translate('settings.list.edit_custom_precision_level')}
                </span>
                <a className="close_button" onClick={this.closeModal}>
                  <img src={closeBtn} alt="" />
                </a>
              </h2>
              <Scrollbars
                //style={{
                //overflow: 'hidden',
                //position: 'relative',
                //}}
                renderTrackHorizontal={() => {
                  return <div />;
                }}
                renderThumbHorizontal={() => {
                  return <div />;
                }}
                autoHeight
                autoHeightMin={350}
                autoHeightMax={350}
              >
                <div className="popup_content">
                  {
                    errorCode !== null
                    && (
                      <div className="error">
                        <span>{errorCode}</span>
                      </div>
                    )
                  }
                  <div className="popup_content_item">
                    <List>
                      <List.Item style={{ fontWeight: 'normal', fontSize: '12px' }}>
                        <List.Header>
                          {translate('settings.list.minimum_unique_rate')}
                          <Popup
                            trigger={<Icon name="redo" style={{ cursor: 'pointer', marginLeft: '5px' }} onClick={this.handleResetConfig} />}
                            content="Set default"
                            inverted
                            size="small"
                            style={{ fontSize: '12px', fontWeight: '600' }}
                          />
                        </List.Header>
                        <List.List>
                          <label>Default</label>
                          <Input
                            type="number"
                            onChange={this.handleMURChange}
                            value={precisionConfig.value_2 || ''}
                            label={{ basic: true, content: '%' }}
                            labelPosition="right"
                            placeholder="40"
                            minLength="0"
                            maxLength="3"
                            error={is_minimum_unique_rate_error}
                          />
                        </List.List>
                      </List.Item>
                    </List>
                  </div>
                  <div className="popup_content_item">
                    <List>
                      <List.Item style={{ fontWeight: 'normal', fontSize: '12px' }}>
                        <List.Header>{translate('settings.list.minimum_extracted_identifier')}</List.Header>
                        <List.List>
                          <label>Default</label>
                          <Input
                            type="number"
                            style={{ width: '114px' }}
                            onChange={this.handleMEIChange}
                            value={precisionConfig.value_1 || ''}
                            placeholder="10"
                            minLength="0"
                            maxLength="8"
                            error={is_minimum_extracted_identifier_error}
                          />
                        </List.List>
                      </List.Item>
                    </List>
                  </div>
                </div>
              </Scrollbars>
              <div className="button_wrap">
                <a onClick={this.closeModal}>{translate('modal.button.cancel')}</a>
                <a className="save" onClick={this.onSubmit}>{translate('modal.button.save')}</a>
              </div>
            </div>
          </div>
        </div>
      );
    };
    return (
      <Modal open={isOpenMPL} onClose={this.closeModal}>
        {getModalContent()}
      </Modal>
    );
  }
}

export default PrecisionLevelModal;
